import React, { useEffect } from "react";
import { func, node } from "prop-types";

import "./popupModal.m.css";

const PopupModal = ({ closePopup, children }) => {
  const handleKeyUp = e => {
    if (e.keyCode === 27) {
      e.preventDefault();
      closePopup();
    }
  };

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUp, false);
    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollY);
      window.removeEventListener("keyup", handleKeyUp, false);
    };
  });

  return (
    <React.Fragment>
      <div styleName="modal-wrapper" onClick={closePopup} />
      <div styleName="modal">{children}</div>
    </React.Fragment>
  );
};

PopupModal.propTypes = {
  closePopup: func,
  children: node
};

export default PopupModal;
